import { render, staticRenderFns } from "./NumberFilter.vue?vue&type=template&id=8b86d86e&scoped=true&"
import script from "./NumberFilter.vue?vue&type=script&lang=ts&"
export * from "./NumberFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b86d86e",
  null
  
)

export default component.exports